module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marginLeft upper-parent"
  }, [_c('div', {
    staticClass: "same-line itemsContainer inline-block upper-parent-child1"
  }, [_c('div', {
    staticClass: "offer-name"
  }, [(_vm.gettersSelectedOffer && _vm.gettersSelectedOffer.name) ? _c('div', [_vm._v("\n        " + _vm._s(this.gettersSelectedOffer.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatedItemName && _vm.duplicatedItemName.name) ? _c('div', {
    staticClass: "item-text"
  }, [_vm._v("\n        " + _vm._s(_vm.duplicatedItemName.name) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('searchable-dropdown', {
    attrs: {
      "id": "waterfall1",
      "list": _vm.itemArrays,
      "selectedItem": _vm.selectedItem ? this.selectedItem.name : ''
    },
    model: {
      value: (_vm.selectedItem),
      callback: function($$v) {
        _vm.selectedItem = $$v
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block upper-parent-child2",
    style: ({
      'width': '80%'
    })
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('vue-chart', {
    attrs: {
      "chart-type": "CandlestickChart",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "version": 45,
      "options": _vm.options
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d991d9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts-simulation/Waterfall.vue
// module id = 369
// module chunks = 2